var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 64,
    viewBox: "0 0 110 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1528 10.149C28.1528 10.149 31.8726 7.14673 38.3822 7.7289C43.4951 8.18615 50.0965 13.941 50.0965 13.941L22.7479 41.6738C22.7479 41.6738 19.1357 44.3055 14.3155 44.4564C9.49539 44.6074 -0.000130299 38.6974 -0.000130299 38.6974L28.1528 10.149Z",
    fill: "url(#paint0_linear_372_26196)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0986 13.9355L48.3369 26.3843L24.0856 50.9763L25.5111 38.8685L50.0986 13.9355Z",
    fill: "url(#paint1_linear_372_26196)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1465 13.0562L85.2073 25.6849L60.1741 50.7087L61.9373 38.6194L87.1465 13.0562Z",
    fill: "url(#paint2_linear_372_26196)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0672 12.4842C62.0672 12.4842 65.885 7.45491 72.8933 7.02163C78.8184 6.65532 87.1822 13.0604 87.1822 13.0604L50.3049 50.4558C50.3049 50.4558 45.4655 54.8756 39.1752 56.0138C32.3611 57.2467 24.1053 50.9795 24.1053 50.9795L62.0672 12.4842Z",
    fill: "url(#paint3_linear_372_26196)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5052 21.9931C88.5052 21.9931 92.0139 18.9411 98.6186 19.3784C103.636 19.7107 109.999 25.2183 109.999 25.2183L82.4862 53.1181C82.4862 53.1181 79.277 55.767 74.1318 56.0481C68.4471 56.3587 60.1827 50.7135 60.1827 50.7135L88.5052 21.9931Z",
    fill: "url(#paint4_linear_372_26196)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_372_26196",
    x1: 43.6762,
    y1: 7.43053,
    x2: 5.90149,
    y2: 44.6819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_372_26196",
    x1: 52.7273,
    y1: 16.6011,
    x2: 21.0207,
    y2: 47.8684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_372_26196",
    x1: 89.7751,
    y1: 15.7217,
    x2: 57.2764,
    y2: 47.7702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93C4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4ED6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_372_26196",
    x1: 80.7619,
    y1: 6.54995,
    x2: 29.8258,
    y2: 56.7804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_372_26196",
    x1: 103.831,
    y1: 18.9634,
    x2: 65.8291,
    y2: 56.4392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D67D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsLogo);
export default __webpack_public_path__ + "static/media/ads-logo.ea71bed44fea4929d431d83f492f229e.svg";
export { ForwardRef as ReactComponent };